import React from 'react';
import { LogOut, Moon, Sun } from 'lucide-react';
import RoutingTab from './RoutingTab';
import { ROLE_LABELS } from '../lib/accountService';

/** What managers, salespeople and staff see: the lead-routing view and nothing else.
 *  The server enforces the same limit, so this is a convenience, not the security boundary. */
export default function StaffShell({ apiUrl, user, theme, onToggleTheme, onLogout, initialLeadId, onInitialHandled, onChangePassword }) {
  return (
    <div className="app-container executive-app staff-shell" data-testid="staff-shell">
      <header className="staff-shell-bar">
        <strong>Haique · Lead Routing</strong>
        <span className="staff-shell-who" data-testid="staff-who">
          {user?.display_name || user?.username} · {ROLE_LABELS[user?.role] || user?.role}
        </span>
        <button type="button" className="logout-btn" onClick={onChangePassword} data-testid="change-password-btn">Password</button>
        <button type="button" onClick={onToggleTheme} aria-label="Toggle theme" className="logout-btn">
          {theme === 'light' ? <Moon size={16} /> : <Sun size={16} />}
        </button>
        <button type="button" className="logout-btn" onClick={onLogout} data-testid="logout-btn">
          <LogOut size={16} /> Sign out
        </button>
      </header>
      <main className="main-content page-scroll">
        <RoutingTab apiUrl={apiUrl} user={user} initialLeadId={initialLeadId} onInitialHandled={onInitialHandled} />
      </main>
    </div>
  );
}
